<div class="modal-header">
  <h2>
    {{
      partnerInvite
        ? 'Invite Partner User to this Account'
        : 'Invite Staff User to this Account'
    }}
  </h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<hr />
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <app-search-dropdown
        [placeholder]="'Find users by email (min 3 characters)'"
        [search]="usersSearch$"
        [searchFailed]="searchFailed"
        [searching]="searching"
        (reset)="reset()"
        (selectItem)="selectItem($event)"
      ></app-search-dropdown>
    </div>
  </div>
  <div class="row">
    <div *ngIf="!partnerInvite" class="col-6">
      <label for="dropdown-menu-left">Permissions:</label>
      <div
        ngbDropdown
        placement="bottom-left"
        class="btn-group dropdown-menu-left"
      >
        <button
          type="button"
          class="btn btn-primary dropdown-toggle"
          id="staffUserDropdown"
          [disabled]="!userToInvite"
          ngbDropdownToggle
        >
          <i class="fas fa-lock"></i> With permissions of
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownToggleSplit">
          <button
            ngbDropdownItem
            class="dropdown-item"
            (click)="selectPermissions(UserRoles.Admin)"
          >
            <b>Admin</b>
          </button>
          <ng-container *ngFor="let user of accountUsers">
            <button
              ngbDropdownItem
              class="dropdown-item"
              (click)="selectPermissions(user)"
            >
              {{ user.name }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-6">
      <form [formGroup]="form">
        <label for="form-control">Remove access after:</label>
        <select class="form-control" formControlName="expire">
          <option *ngFor="let time of expireTimeOptions" [value]="time.value">
            {{ time.text }}
          </option>
        </select>
      </form>
    </div>
  </div>
  <div *ngIf="userToInvite?.userId" class="row summary">
    <div class="col">
      <p>
        You are about to add <b>{{ userToInvite?.name }}</b> as
        {{ partnerInvite ? 'Partner' : 'Staff' }} User
        <ng-container *ngIf="copyUser">
          <b>
            {{
              copyUser === UserRoles.Admin
                ? 'with ' + copyUser + ' role'
                : 'with the roles and permissions of ' + copyUser
            }}
          </b>
          to the following account:
        </ng-container>
      </p>

      <div class="sum">
        <p><b>Account:</b> {{ accountId }}</p>
        <p><b>With permissions of:</b> {{ copyUser }}</p>
      </div>

      <p>
        Note: The user will automatically be removed from the account after
        <b>{{ expireString }}</b>
      </p>
    </div>
  </div>
</div>
<hr />
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
    [disabled]="state === formStates.submitting"
  >
    Cancel
  </button>
  <span [ngbTooltip]="submitToolTip">
    <button
      type="button"
      class="btn btn-success"
      (click)="onConfirm()"
      [disabled]="disableSubmit"
    >
      <i class="fas fa-check"></i> <span>Invite</span>
    </button>
  </span>
</div>

<div *ngIf="state === formStates.submitting" class="loading">
  <app-loading-spinner></app-loading-spinner>
</div>
